import { IntegrationsSort } from 'models'

export const defaultIntegrationsCategories = ['SOC', 'VM']

export const integrationsInstancesOptions = ['Configured Instances', 'Not configured Instances']

export const integrationsSortOptionsInstances = [
  IntegrationsSort.AZ,
  IntegrationsSort.ZA,
  IntegrationsSort.LatestCreated,
  IntegrationsSort.OldestCreated
] as IntegrationsSort[]

export const integrationsSortOptionsIntegrations = [
  IntegrationsSort.AZ,
  IntegrationsSort.ZA,
  IntegrationsSort.NewestFirst,
  IntegrationsSort.OldestFirst
] as IntegrationsSort[]

// The sidebar splits this page out as Data Sources only while ticketing systems are enabled.
export const DATA_SOURCES_PAGE_TITLE = 'Data Sources'

export const INTEGRATIONS_PAGE_TITLE = 'Integrations'

export const DIRECTORY_TAB_LABEL = 'Directory'
